import {
    Component,
    Input,
    OnInit,
    ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '@library-shared/base/base.component';
import { CCInfo } from '@library-shared/models/cc-info';
import { spSite_Client_By_DomainX } from '@models/StoredProcs-Extended/spSite_Client_By_DomainX';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { GlobalService } from '@services/global.service';
import { PaymentService } from '@services/payment/payment.service';
import validationEngine from 'devextreme/ui/validation_engine';
import { ConfirmPaymentDialogComponent } from '../confirm-payment-dialog/confirm-payment-dialog.component';

@Component({
    selector: 'app-finalize-payment',
    templateUrl: './finalize-payment.component.html',
    styleUrls: ['./finalize-payment.component.scss'],
    standalone: false
})
export class FinalizePaymentComponent extends BaseComponent implements OnInit {
    @ViewChild('confirmPayment') confirmPayment: ConfirmPaymentDialogComponent;

    @Input() validationGroup;
    @Input() ccInfo: CCInfo;
    @Input() processingFee = 0;
    @Input() totalWithFee = 0;
    @Input() feeReady = false;
    @Input() pageLoaderID: string;
    @Input() site: spSite_Client_By_DomainX;

    messages: string[] = [];
    allowInput = true;
    failure = false;

    constructor(
        private router: Router,
        private paymentService: PaymentService,
        private authenticationService: AuthenticationService,
        private globalService: GlobalService
    ) {
        super();
    }

    ngOnInit(): void {}

    messageClass(): any {
        if (this.failure) {
            return 'warning-message';
        }
        return '';
    }

    confirmPaymentCheck() {
        const valid = validationEngine.validateGroup(this.validationGroup);

        if (valid.isValid && this.feeReady) {
            this.confirmPayment.showDialog(this.totalWithFee);
        }
    }

    onPaymentConfirmation(confirmed: boolean) {
        if (confirmed) {
            this.allowInput = false;
            this.isLoading2.set(true);
            this.paymentService.Process_Payment({ ccInfo: this.ccInfo }).subscribe({
                next: (data) => {
                    if (data.success) {
                        this.failure = false;
                        this.messages = data.messages;
                        this.authenticationService.Session_Start().subscribe({
                            next: (data2) => {
                                this.globalService.authenticationToken = data2.record.session_id;
                                this.router.navigateByUrl(`/receipt/${data.record.payment_id}`);
                            },
                        });
                    } else {
                        this.failure = true;
                        this.toast_error({ message: data.message });
                        this.messages = data.messages;
                        this.allowInput = true;
                    }
                    this.isLoading2.set(false);
                },
            });
        }
    }

    back() {
        if (this.allowInput) {
            this.router.navigateByUrl('/ticketselect');
        } else {
            this.router.navigateByUrl('/search');
        }
    }

    cancel() {
        this.router.navigateByUrl('/search');
    }
}
